"use strict";
exports.__esModule = true;
exports.findPresetByPermissions = exports.getPermissionsByPreset = exports.PERMISSIONS_BY_PRESET = exports.PRESETS = exports.ROLES = exports.deleteFieldPermanently = exports.restoreField = exports.markFieldDeleted = exports.updateField = exports.addField = exports.setPermissions = exports.setAuthorizationConfig = exports.setNamespace = exports.setDisplayName = exports.setDisplayField = exports.restoreSchema = exports.removeSchema = exports.updateSchema = exports.createSchema = exports.createCollectionsApi = void 0;
var api_1 = require("./api");
exports.createCollectionsApi = api_1["default"];
var operations_1 = require("./commands/operations");
exports.createSchema = operations_1.createSchema;
exports.updateSchema = operations_1.updateSchema;
exports.removeSchema = operations_1.removeSchema;
exports.restoreSchema = operations_1.restoreSchema;
var schemaProperties_1 = require("./commands/schemaProperties");
exports.setDisplayField = schemaProperties_1.setDisplayField;
exports.setDisplayName = schemaProperties_1.setDisplayName;
exports.setNamespace = schemaProperties_1.setNamespace;
exports.setAuthorizationConfig = schemaProperties_1.setAuthorizationConfig;
exports.setPermissions = schemaProperties_1.setPermissions;
var fields_1 = require("./commands/fields");
exports.addField = fields_1.addField;
exports.updateField = fields_1.updateField;
exports.markFieldDeleted = fields_1.markFieldDeleted;
exports.restoreField = fields_1.restoreField;
exports.deleteFieldPermanently = fields_1.deleteFieldPermanently;
var wix_data_schema_types_1 = require("@wix/wix-data-schema-types");
var permissionsPresets_1 = require("./permissionsPresets");
exports.PRESETS = permissionsPresets_1.Preset;
exports.PERMISSIONS_BY_PRESET = permissionsPresets_1.PermissionsByPreset;
exports.getPermissionsByPreset = permissionsPresets_1.getPermissionsByPreset;
exports.findPresetByPermissions = permissionsPresets_1.findPresetByPermissions;
var ROLES = {
    ADMIN: wix_data_schema_types_1.PermissionRole.admin,
    ANYONE: wix_data_schema_types_1.PermissionRole.anyone,
    SITE_MEMBER: wix_data_schema_types_1.PermissionRole.siteMember,
    SITE_MEMBER_AUTHOR: wix_data_schema_types_1.PermissionRole.siteMemberAuthor
};
exports.ROLES = ROLES;
//# sourceMappingURL=index.js.map